import React from 'react';
import Slider from 'react-slick';
import { generateEvent } from '../../../utils/dataGrinch';
import { addCustomerType } from '../../../utils/products';
import properties from '../../../modules/ajio-util/properties';
import { replaceWithJioCDN } from '../../../utils/imageHandling';
import { getProductItemPDP, segmentEventPush } from '../../../modules/ga/GTMdatalayer';

export default class ColorVariant extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showcolor: false, colorSwatchRadioCount:0 };
    this.sliderInstanceRef = React.createRef()
    this.handletoggle = this.handletoggle.bind(this);
    this.initKeyboardRadioGroup = this.initKeyboardRadioGroup.bind(this)
    this.arrowObserver = null;
  }

  handletoggle = e => {
    this.setState({ showcolor: true });
  };

  initKeyboardRadioGroup(groupId) {
    const group = document.getElementById(groupId);
    if (!group) return;

    const radios = Array.from(group.querySelectorAll('[role="radio"]'));

    this.setState({ colorSwatchRadioCount: radios.length });

    // Set correct tabIndex on load
    radios.forEach((radio) => {
      const isChecked = radio.getAttribute('aria-checked') === 'true';
      radio.setAttribute('tabindex', isChecked ? '0' : '-1');
    });

    function setFocus(radio) {
      radios.forEach(r => r.setAttribute('tabindex', r === radio ? '0' : '-1'));
      radio.focus();
    }

    function setChecked(radio) {
      radios.forEach(r => {
        const isSelected = r === radio;
        r.setAttribute('aria-checked', String(isSelected));
      });
    }

    group.addEventListener('keydown', function (e) {
      const active = document.activeElement;
      if (!radios.includes(active)) return;

      const currentIndex = radios.indexOf(active);
      let nextIndex = -1;

      switch (e.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          e.preventDefault();
          nextIndex = (currentIndex + 1) % radios.length;
          setFocus(radios[nextIndex]);
          if (this.sliderInstanceRef?.current) {
            this.sliderInstanceRef.current.slickGoTo(nextIndex)
          }
          break;

        case 'ArrowLeft':
        case 'ArrowUp':
          e.preventDefault();
          nextIndex = (currentIndex - 1 + radios.length) % radios.length;
          setFocus(radios[nextIndex]);
          if (this.sliderInstanceRef?.current) {
            this.sliderInstanceRef.current.slickGoTo(nextIndex)
          }
          break;

        case ' ':
        case 'Spacebar': // legacy
        case 'Enter':
          e.preventDefault();

          // Set checked and simulate a real click to trigger navigation
          setChecked(active);
          active.click();
          break;
      }
    });


  }

  componentDidMount(){
    this.initKeyboardRadioGroup('color-swatch-radiogroup');

    if (this.sliderInstanceRef?.current) {
      const slider = this.sliderInstanceRef.current.innerSlider;

      // Assign aria attributes to the slick list
      slider.list.setAttribute('id', 'color-swatch-radiogroup');
      slider.list.setAttribute('role', 'radiogroup');
      slider.list.setAttribute('aria-describedby', 'select-color-title-id');

      // Select both previous and next arrows
      const arrows = slider.list.parentElement.querySelectorAll('.slick-arrow');

      // Set initial tabIndex
      arrows.forEach(btn => {
        const isDisabled = btn.classList.contains('slick-disabled');
        btn.tabIndex = isDisabled ? -1 : 0;
        btn.disabled = isDisabled? true: false;
      });

      // Observe class changes
      this.arrowObserver = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const btn = mutation.target;
            const isDisabled = btn.classList.contains('slick-disabled');
            btn.tabIndex = isDisabled ? -1 : 0;
            btn.disabled = isDisabled? true: false;
          }
        });
      });

      // Start observing each arrow for class changes
      arrows.forEach(btn => {
        this.arrowObserver.observe(btn, { attributes: true, attributeFilter: ['class'] });
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.showcolor !== this.state.showcolor) {
      // to calculate color swatch count again
      this.initKeyboardRadioGroup('color-swatch-radiogroup');
    }
  }

  componentWillUnmount() {
    if (this.arrowObserver) {
      this.arrowObserver.disconnect();
      this.arrowObserver = null;
    }
  }


  render() {
    let productData = this.props.productData;
    let colorVariantOptions = this.props.colorVariantData;
    let colorSwatchVariant;
    let onSelectColor = this.props.onSelectColor;
    let selectedColor = colorVariantOptions?.selected.code;
    const { showcolor } = this.state;
    let slickSettings = {
      dots: false,
      infinite: false,
      lazyLoad:false,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      autoplay: false,
      className: 'color-swatch-slick'
    };
    let selctedColorName = '';
    let selectedMetalName = '';
    let morecolors = '';
    let colorViewRange = this.props.viewRender === 'quickview' ? 5 : 6;
    const { metalPurity, luxeEventPush } = this.props;
    const newDesignLuxe = this.props.newDesignLuxe;
    var arr = [];
    let newluxeColor = [];
    if (colorVariantOptions && colorVariantOptions?.options?.length) {
      colorVariantOptions?.options?.forEach((color, i) => {
        let colorSelected = false;
        if (color.code === selectedColor) {
          colorSelected = true;
        }
        color.variantOptionQualifiers.forEach((colorSwatch, j) => {
          const { swatchImage } = colorSwatch;
          const { url = '' } = swatchImage || {};
          if (colorSwatch.name === 'Color' && url) {
            arr.push({
              code: color.code,
              productUrl: color.url,
              url,
              value: colorSwatch.value,
              colorSelected
            });
            if (colorSelected) {
              selctedColorName = colorSwatch.value || '';
            }
          } else if (metalPurity && colorSwatch.qualifier === 'metalPurity') {
            arr.push({
              code: color.code,
              productUrl: color.url,
              url,
              value: colorSwatch.value,
              colorSelected
            });
            if (colorSelected) {
              selectedMetalName = colorSwatch.value || '';
            }
          }
        });
      });
    }
    if (!showcolor) {
      newluxeColor = arr.slice(0, colorViewRange);
    } else newluxeColor = arr;
    let colorVariant = '';
    if (arr.length) {
      colorVariant = arr.map((color, i) => {
        let colorSel = 'swatch-image-notselected';
        let selectedswatch;
        if (color.colorSelected) {
          colorSel = 'swatch-image-selected';
          selectedswatch = 'selected';
        }
        if (color.url || metalPurity) {
          return (
            <div 
              key={i} 
              className={`color-swatch ${selectedswatch}`}
              // aria-checked={selectedswatch === 'selected' ? "true" : "false"}
              // tabIndex={i === 0 ? 0 : -1}
            >
              {this.props.viewRender === 'quickview' ? (
                <div
                  className="swatch-item"
                  onClick={() => {
                    generateEvent({
                      Event: 'ColourVariantSelection',
                      value: {
                        ColourVariantSelected: color.code
                      }
                    });
                    onSelectColor(color.code);
                  }}
                  role="radio"
                  aria-posinset={i + 1}
                  aria-setsize={this.state.colorSwatchRadioCount}
                  aria-label={color.value}
                  aria-checked={selectedswatch === 'selected' ? "true" : "false"}
                >
                  {metalPurity ? (
                    <div
                      className={`oval size-variant-item size-instock ${
                        color.colorSelected ? 'selected' : ''
                      }`}
                    >
                      {color.value}
                    </div>
                  ) : (
                    <>
                      <img
                        className={`swatch-image ${colorSel}`}
                        src={`${replaceWithJioCDN(color.url)}`}
                        alt={color.value}
                        title={color.value}
                      />
                      {newDesignLuxe ? (
                        <div className="color-swatch-title">{color.value}</div>
                      ) : null}
                    </>
                  )}
                </div>
              ) : (
                <a
                  href={addCustomerType(color.productUrl)}
                  className="swatch-item"
                  onClick={() => {
                    if (newDesignLuxe) {
                      luxeEventPush({
                        eventName: 'product_variant_change',
                        event_action: 'variant change',
                        event_label: color.code
                      });

                      segmentEventPush({
                        event: 'Product Color Selected',
                        color_selected: color?.code || '',     
                        ...(productData && ({
                          products:[{
                             ...getProductItemPDP(productData)
                          }]
                        }
                        )),
                        screen_name : 'PDP Page',
                        screen_source:'Color Variant',
                        swatch_source: colorSwatchVariant,
                      });
                      
                    } else {
                      generateEvent({
                        Event: 'ColourVariantSelection',
                        value: {
                          ColourVariantSelected: color.code
                        }
                      });

                      segmentEventPush({
                        event: 'Product Color Selected',
                        color_selected: color?.code || '',     
                        ...(productData && ({
                          products:[{
                             ...getProductItemPDP(productData)
                          }]
                        }
                        )),
                        screen_name : 'PDP Page',
                        screen_source:'Color Variant',
                        swatch_source: colorSwatchVariant,
                      });
                    }
                  }}
                  role="radio"
                  aria-posinset={i + 1}
                  aria-setsize={this.state.colorSwatchRadioCount}
                  aria-label={color.value}
                  aria-checked={selectedswatch === 'selected' ? "true" : "false"}
                  // adding tabIndex here to 1) avoid adding it to parent div to prevent redundant onClick handlers. 2) React Slick adds tabIndex -1 to all slide items
                  // tabIndex={0}
                >
                  {metalPurity ? (
                    <div
                      tabIndex={0}
                      className={`oval size-variant-item size-instock ${
                        color.colorSelected ? 'selected' : ''
                      }`}
                    >
                      {color.value}
                    </div>
                  ) : (
                    <img
                      className={`swatch-image ${colorSel}`}
                      src={`${replaceWithJioCDN(color.url)}`}
                      alt={color.value}
                      title={color.value}
                    />
                  )}
                  {newDesignLuxe ? <div className="color-swatch-title">{color.value}</div> : null}
                </a>
              )}
            </div>
          );
        } else {
          return null;
        }
      });
    }

    if (colorVariantOptions && colorVariantOptions.options.length > 5) {
      colorSwatchVariant = (
        <div>
            <div 
              id='select-color-title-id'
              style={{
                height:0,
                width:0,
                pointerEvents:'none',
                opacity:"0",
                position:"absolute"
              }}>Select {metalPurity ? 'Metal Purity' : 'Color'}</div>
           <Slider {...slickSettings} ref={this.sliderInstanceRef}>
              {colorVariant}
          </Slider>
        </div>

      );
    } else {
      colorSwatchVariant = colorVariant;
    }
    const showCount = metalPurity ? 0 : 1;
    const colorOptionsExist = newluxeColor.some(arr => arr.url);
    return (
      <>
        {newDesignLuxe ? (
          <>
            {arr.length >= showCount && colorOptionsExist ? (
              <div className="color-variant-block" role="radiogroup">
                <div className="color-selection">
                  <strong>Select Color</strong>
                </div>
                <div
                  className={`newluxe-colorswatch-container d-flex flex-wrap mt-4 ${
                    showcolor ? 'less-color' : 'more-color'
                  }`}
                  id="color-swatch-radiogroup"
                  role="radiogroup"
                  aria-describedby="select-color-title-id"
                >
                  <div
                    id="select-color-title-id"
                    style={{
                      height: 0,
                      width: 0,
                      pointerEvents: 'none',
                      opacity: '0'
                    }}
                  >
                    Select {metalPurity ? 'Metal Purity' : 'Color'}
                  </div>
                  {newluxeColor.map((color, i) => {
                    return (
                      <div
                        key={i}
                        className="newluxe-swatch-header mx-2"
                        onClick={() => {
                          if (this.props.viewRender === 'quickview') {
                            generateEvent({
                              Event: 'ColourVariantSelection',
                              value: {
                                ColourVariantSelected: color.code
                              }
                            });
                            onSelectColor(color.code);
                          } else {
                            window.location = addCustomerType(color.productUrl);
                            if (newDesignLuxe) {
                              luxeEventPush({
                                eventName: 'product_variant_change',
                                event_action: 'variant change',
                                event_label: color.code
                              });
                              segmentEventPush({
                                event: 'Product Color Selected',
                                 color_selected: color.code || '',
                                 products:[{
                                  ...getProductItemPDP(productData)
                                 }],
                                screen_name : 'PDP Page',
                                screen_source:'Color Variant',
                                swatch_source: colorSwatchVariant,
                              });
                            } else {
                              generateEvent({
                                Event: 'ColourVariantSelection',
                                value: {
                                  ColourVariantSelected: color.code
                                }
                              });
                              segmentEventPush({
                                event: 'Product Color Selected',
                                 color_selected: color.code,
                                 products:[{
                                 ...getProductItemPDP(productData)
                                 }],     
                                screen_name : 'PDP Page',
                                screen_source:'Color Variant',
                                swatch_source: colorSwatchVariant,
                              });
                            }
                          }
                        }}
                        role="radio"
                        aria-posinset={i + 1}
                        aria-setsize={this.state.colorSwatchRadioCount}
                        aria-label={color.value}
                        aria-checked={color.colorSelected ? 'true' : 'false'}
                      >
                        <div
                          className={`newluxe-swatch-image ${
                            color.colorSelected ? 'active' : 'inactive'
                          } d-flex justify-content-center`}
                        >
                          <img
                            className={`swatch-image ${
                              color.colorSelected ? 'active' : 'inactive'
                            }`}
                            src={`${replaceWithJioCDN(color.url)}`}
                            alt={color.value}
                            title={color.value}
                          />
                        </div>
                        <div className="newluxe-swatch-title">{color.value}</div>
                      </div>
                    );
                  })}
                  {/* View More Button */}
                  {!showcolor && arr.length > colorViewRange ? (
                    <div className="view-more mx-2" onClick={this.handletoggle} role='button' tabIndex={0} aria-label='View more colors'>
                      <div className="new-luxe-viewmore d-flex flex-wrap">
                        <img
                          src={`${properties.getProperty(
                            'imageBaseUrl'
                          )}/static/img/addMorePlus.svg`}
                          alt="Plus icon"
                          title="view-more"
                        />
                      </div>
                      <div className="newluxe-viewmore-title text-center">View More</div>
                    </div>
                  ) : null}
                </div>
              </div>
            ) : null}
          </>
        ) : (
          <fieldset style={{border: "none",margin: 0,padding: 0}}>
            {/* <legend className="sr-only">
              {metalPurity ? 'Select Metal Purity' : selctedColorName}
            </legend> */}
            <p
              className="prod-color"
              aria-label={metalPurity ? 'Select Metal Purity' : selctedColorName}
            >
              {metalPurity ? 'Select Metal Purity' : selctedColorName}
            </p>
            <div
              className="color-variant-block"
              id="color-swatch-radiogroup"
              role="radiogroup"
              aria-describedby="select-color-title-id"
            >
              <div
                id="select-color-title-id"
                style={{
                  height: 0,
                  width: 0,
                  pointerEvents: 'none',
                  opacity: '0'
                }}
              >
                Select {metalPurity ? 'Metal Purity' : 'Color'}
              </div>
              {arr.length >= showCount ? colorSwatchVariant : ''}
            </div>
          </fieldset>
        )}
      </>
    );
  }
}
